var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35206 21.242C8.78721 21.7922 9.34171 22.2364 9.97368 22.541C10.6056 22.8455 11.2985 23.0025 12.0001 23C12.7016 23.0025 13.3945 22.8455 14.0264 22.541C14.6584 22.2364 15.2129 21.7922 15.6481 21.242C13.2271 21.5702 10.773 21.5702 8.35206 21.242Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7501 10.704V10C18.7501 6.134 15.7271 3 12.0001 3C8.27306 3 5.25006 6.134 5.25006 10V10.704C5.25006 11.549 5.01006 12.375 4.55806 13.078L3.45006 14.801C2.43906 16.375 3.21106 18.514 4.97006 19.011C9.56631 20.313 14.4338 20.313 19.0301 19.011C20.7891 18.514 21.5611 16.375 20.5501 14.801L19.4421 13.078C18.9885 12.3693 18.749 11.5454 18.7501 10.704ZM12.0001 6.25C12.199 6.25 12.3897 6.32902 12.5304 6.46967C12.671 6.61032 12.7501 6.80109 12.7501 7V11C12.7501 11.1989 12.671 11.3897 12.5304 11.5303C12.3897 11.671 12.199 11.75 12.0001 11.75C11.8011 11.75 11.6104 11.671 11.4697 11.5303C11.3291 11.3897 11.2501 11.1989 11.2501 11V7C11.2501 6.80109 11.3291 6.61032 11.4697 6.46967C11.6104 6.32902 11.8011 6.25 12.0001 6.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarm);
export default __webpack_public_path__ + "static/media/icon_alarm.e429ddad2f51ea3eda8fd69f510372dc.svg";
export { ForwardRef as ReactComponent };